// extracted by mini-css-extract-plugin
export default {"noPaddingBottom":"EC6u5TkhpmazY6ixzw7B__noPaddingBottom___","menuTabs":"Z9ZVT4om0pAEU0BmTZBQ__menuTabs___","menuTabItem":"jLZkWjnzFXXkrej_hrkM__menuTabItem___"};